import React from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { progressCheckColumns } from '../../Data/ProgressCheckManagement/ProgressCheckListData'
import { getAllData, deleteIdData } from '../../lib/progressCheck'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminProgressCheckList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: progressChecks, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)

	const sortedProgressChecks = React.useMemo(() => {
		return [...progressChecks].sort((a, b) => {
			// Sort by order first, then by type
			if (a.order !== b.order) {
				return (a.order || 0) - (b.order || 0)
			}
			const typeA = a.type ? a.type : ''
			const typeB = b.type ? b.type : ''
			return typeA.localeCompare(typeB)
		})
	}, [progressChecks])

	return (
		<DataManagementGrid
			title="Progress Checks"
			subTitle="Manage all progress checks in the system"
			breadcrumbTitle="Progress Check Management"
			breadcrumbMainTitle="Progress Check Management"
			columns={(layout, role) => progressCheckColumns(layout, role)}
			data={sortedProgressChecks}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search by description, type, or score..."
			createButtonText="Add New Progress Check"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/progress-check/create/${layout}`}
			onDelete={handleDelete}
			searchFields={['description', 'type', 'score', 'order']}
			noDataMessage="No progress checks found"
		/>
	)
}

export { AdminProgressCheckList }
